import { MeasureUnitUI } from '../types/interfaces';

export const MeasureUnitTemplate: MeasureUnitUI = {
  id: 0,
  name: '',
  description: '',
  shortName: ''
};
